import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SalesDeliveryService {

  private _baseUrl = `${environment.apiURL}/api`;

  constructor(private http: HttpClient) {}
  getAllSalesDeliveries() {
    return this.http.get<any>(`${this._baseUrl}/SalesDelivery`);
  }

  getPaginatedSalesDeliveries(
    pageIndex = 0,
    pageSize = 10,
    pagination = false,
    criteria = null
  ) {
    return this.http.get<any>(
      `${this._baseUrl}/SalesDelivery/paginated?pageIndex=${pageIndex}&pageSize=${pageSize}&pagination=${pagination}${criteria != null ? '&criteria=' + criteria : ''}`
    );
  }

  getSalesDeliveryById(id: number) {
    return this.http.get<any>(`${this._baseUrl}/SalesDelivery/${id}`);
  }
}
